import cx from "classnames"
import Icon from "src/shared/icons"
import "./CalendarButtons.css"
import { CalendarButtonsProps } from "./CalendarButtons.props"
import useGetCurrentDate from "src/shared/hooks/useGetCurrentDate"

const CalendarButtons = ({
    currDay,
    setCurrDay,
    currMonth,
    setCurrMonth,
    currYear,
    setCurrYear,
    monthNames,
    className,
    allowFutureDates = false,
}: CalendarButtonsProps) => {
    const days = new Date(currYear, currMonth + 1, 0).getDate()
    const { currentDate } = useGetCurrentDate()

    const disableNextMonth = !allowFutureDates && (currYear + 1) > currentDate.getFullYear() && (currMonth + 1) > currentDate.getMonth()
    const isNextYearDisabled = !allowFutureDates && (currYear + 1) > currentDate.getFullYear()

    const isNextDayDisabled = !allowFutureDates && (currDay ? (() => {
        const nextDay = new Date(currYear, currMonth, currDay + 1)
        return nextDay > currentDate
    })() : false)

    return (
        <div className={cx("calendario-reservaciones__control", className)}>
            <div className="calendario-reservaciones__control-date-month">
                <button
                    className="calendario-reservaciones__control-btn"
                    onClick={() => {
                        if (currMonth <= 0) {
                            setCurrYear(currYear - 1)
                            setCurrMonth(11)
                        } else {
                            setCurrMonth(currMonth - 1)
                        }
                    }}
                >
                    <Icon name="chevronleft" color="var(--primary)" />
                </button>
                <p>{monthNames[currMonth]}</p>
                <button
                    disabled={disableNextMonth}
                    style={{ cursor: disableNextMonth ? "not-allowed" : "" }}
                    className="calendario-reservaciones__control-btn"
                    onClick={() => {
                        if (currMonth >= 11) {
                            setCurrYear(currYear + 1)
                            setCurrMonth(0)
                        } else {
                            setCurrMonth(currMonth + 1)
                        }
                    }}
                >
                    <Icon name="chevronRight" color={disableNextMonth ? "var(--placeholder)" : "var(--primary)"} />
                </button>
            </div>
            {currDay && (
                <div className="calendario-reservaciones__control-date-day">
                    <button
                        className="calendario-reservaciones__control-btn"
                        onClick={() => {
                            if (currDay <= 1) {
                                const prevDate = new Date(currYear, currMonth, 0)
                                const newDay = prevDate.getDate()
                                const newMonth = prevDate.getMonth()
                                const newYear = prevDate.getFullYear()
                                if (newYear !== currYear) setCurrYear(newYear)
                                setCurrMonth(newMonth)
                                setCurrDay(newDay)
                            } else {
                                setCurrDay(currDay - 1)
                            }
                        }}
                    >
                        <Icon name="chevronleft" color="var(--primary)" />
                    </button>
                    <p>{currDay}</p>
                    <button
                        disabled={isNextDayDisabled}
                        style={{ cursor: isNextDayDisabled ? "not-allowed" : "" }}
                        className="calendario-reservaciones__control-btn"
                        onClick={() => {
                            if (currDay >= days) {
                                const nextDate = new Date(currYear, currMonth + 1, 1)
                                const newMonth = nextDate.getMonth()
                                const newYear = nextDate.getFullYear()
                                if (newYear !== currYear) setCurrYear(newYear)
                                setCurrMonth(newMonth)
                                setCurrDay(1)
                            } else {
                                setCurrDay(currDay + 1)
                            }
                        }}
                    >
                        <Icon name="chevronRight" color="var(--primary)" />
                    </button>
                </div>
            )}

            <div className="calendario-reservaciones__control-date-year">
                <button className="calendario-reservaciones__control-btn" onClick={() => setCurrYear(currYear - 1)}>
                    <Icon name="chevronleft" color="var(--primary)" />
                </button>
                <p>{currYear}</p>
                <button className="calendario-reservaciones__control-btn" onClick={() => setCurrYear(currYear + 1)} disabled={isNextYearDisabled}
                    style={{ cursor: isNextYearDisabled ? "not-allowed" : "" }}
                >
                    <Icon name="chevronRight" color={isNextYearDisabled ? "var(--placeholder)" : "var(--primary)"} />
                </button>
            </div>
        </div>
    )
}
export { CalendarButtons }
